import { render, staticRenderFns } from "./facility-detail.vue?vue&type=template&id=47bd97b0&scoped=true&"
import script from "./facility-detail.vue?vue&type=script&lang=js&"
export * from "./facility-detail.vue?vue&type=script&lang=js&"
import style0 from "./facility-detail.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./facility-detail.vue?vue&type=style&index=1&id=47bd97b0&lang=scss&scoped=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "47bd97b0",
  null
  
)

export default component.exports